module.exports = __webpack_public_path__ + "static/media/add-icon-af.b3294bf1.svg";